import React from "react";
import './ProductHighlights.css'

const ProductHighlights = () => (
  <section className="product-highlights">
    <h2>¿Por qué elegir la Trimmer Buda?</h2>
    <img src="https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/landings%2Fmaquina%2F23213_480x480-removebg-preview%20(1).png?alt=media&token=8c5f7e2f-cecd-4572-85be-0880041f22b8" alt="" />
    <ul>
      <li>✨ <strong>Elegancia única:</strong> Diseño grabado con detalles de Buda.</li>
      <li>🎯 <strong>Precisión garantizada:</strong> Incluye 4 peines de 1 mm a 4 mm.</li>
      <li>🔋 <strong>Practicidad recargable:</strong> Batería USB para máxima comodidad.</li>
    </ul>
  </section>
);

export default ProductHighlights;
